// extracted by mini-css-extract-plugin
export default {"chosenAddressIFrame":"styles_chosenAddressIFrame__j7XZW","buttonContainer":"styles_buttonContainer__0UDhE","editAddressContainer":"styles_editAddressContainer__mX3QI"};